import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { usersListAll } from "@/api/user";
import { Message } from "element-ui";
import { mapActions } from "vuex";
export default {
  props: {
    showing: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      optionsoRganization: [],
      allList: [],
      id: "",
      form: {
        email: "",
        password: "",
        nickname: "",
        auth_group_id: "",
        parent_id: "",
        id: "",
        status: "1"
      },
      rules: {
        email: [{
          required: true,
          message: "请输入账号",
          trigger: "blur"
        }],
        nickname: [{
          required: true,
          message: "请输入昵称",
          trigger: "blur"
        }],
        auth_group_id: [{
          required: true,
          message: "请选择角色",
          trigger: "change"
        }],
        status: [{
          required: true,
          message: "请选择用户状态",
          trigger: "change"
        }]
      },
      formLabelWidth: "80px"
    };
  },
  computed: {
    isShow: {
      get: function get() {
        if (this.showing) {
          return this.showing;
        }
      },
      set: function set(val) {
        this.$emit("changeShow", false);
      }
    }
  },
  created: function created() {},
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/user", ["queryUsers", "queryupUser", "upUser", "userAdd"])), {}, {
    init: function init(id) {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var type, query, queryupUser;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                type = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : false;
                usersListAll().then(function (res) {
                  if (res.status == 200) {
                    _this.allList = res.data;
                  }
                });
                _this.dialogFormVisible = true;
                _this.id = id;
                _context.next = 6;
                return _this.queryUsers({
                  id: id
                });

              case 6:
                query = _context.sent;
                _this.optionsoRganization = query;

                if (!(id != "t")) {
                  _context.next = 18;
                  break;
                }

                _context.next = 11;
                return _this.queryupUser({
                  id: id
                });

              case 11:
                queryupUser = _context.sent;
                _this.form.email = queryupUser.admin_info.email;
                _this.form.nickname = queryupUser.admin_info.nickname;
                _this.form.parent_id = queryupUser.admin_info.parent_id == 0 ? "" : queryupUser.admin_info.parent_id;
                _this.form.status = String(queryupUser.admin_info.status);
                _this.form.auth_group_id = queryupUser.admin_info.auth_group_id;
                _this.form.id = id;

              case 18:
                if (type) {
                  _this.form.id = "";
                }

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dataReset: function dataReset() {
      this.form.email = "";
      this.form.nickname = "";
      this.form.auth_group_id = "";
      this.form.parent_id = "";
      this.form.id = "";
      this.form.status = "1";
      this.form.password = "";
      this.dialogFormVisible = false;
    },
    resetForm: function resetForm(formName) {
      this.dataReset();
      this.dialogFormVisible = false;
      this.$emit("changeShow", false);
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var query, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = _objectSpread(_objectSpread({}, _this2.form), {}, {
                  parent_id: _this2.form.parent_id ? _this2.form.parent_id : 0
                });

                if (!_this2.form.id) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 4;
                return _this2.upUser(data);

              case 4:
                query = _context2.sent;
                _context2.next = 10;
                break;

              case 7:
                _context2.next = 9;
                return _this2.userAdd(data);

              case 9:
                query = _context2.sent;

              case 10:
                if (query.status == 200) {
                  Message.success(query.message);

                  _this2.$emit("refreshDataList");

                  _this2.resetForm("ruleForm");
                }

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  })
};